import { FiXCircle } from 'react-icons/fi';

import type { ToastMessage } from '~/contexts/ToastContext';

import { TFunctionType } from '../types/utils';

export const TOAST_DURATION = 3500;

export const TOAST_ASYNC_DOWNLOAD_WARNING = (
  t: TFunctionType
): Omit<ToastMessage, 'id'> => ({
  description: t('common.async_download_warning'),
  type: 'neutral',
});

export const TOAST_DOWNLOAD_WARNING = (
  t: TFunctionType
): Omit<ToastMessage, 'id'> => ({
  description: t('common.download_warning'),
  type: 'neutral',
});

export const TOAST_DOWNLOAD_SUCCESSFUL = (
  t: TFunctionType
): Omit<ToastMessage, 'id'> => ({
  description: t('common.download_successful'),
  type: 'success',
});

export const TOAST_DOWNLOAD_NO_FILTER_WARNING = (
  t: TFunctionType
): Omit<ToastMessage, 'id'> => ({
  title: t('common.download_no_filter_warning_title'),
  description: t('common.download_no_filter_warning'),
  icon: <FiXCircle size="24" />,
  type: 'warning',
});
